import services from '@/services';
const TOPICS_PATH = 'topics';
const ITEMS_PATH = 'items';
export default {

    async getTopic(id) {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/${id}`,
            hasToken: true
        });
    },

    async getItem(topic_uid, item_uid) {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/${topic_uid}/${ITEMS_PATH}/${item_uid}`,
            hasToken: true
        });
    },

    getSigns: async () => {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/ddx/signs`,
            timeout: 10000,
            hasToken: true
        });
    },

    postSigns: async ({ signs, species, sex }) => {
        return await services.postAsync({
            url: `/${TOPICS_PATH}/ddx/signs`,
            body: { signs, species, sex },
            timeout: 10000,
            hasToken: true
        });
    },

    getDiagnosis: async (id) => {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/ddx/diagnoses/${id}`,
            timeout: 10000,
            hasToken: true
        });
    },

    getSharedClinicalHandouts: async (token) => {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/handouts`,
            headers: {
                token
            },
            hasToken: false
        });
    },

    shareClinicalHandouts: async (body) => {
        return await services.postAsync({
            url: `/${TOPICS_PATH}/handouts`,
            body,
            hasToken: true
        });
    },

    postClinicalHandoutsAlgorithmsClickEvent: async (token, inputs, latitude, longitude) => {
        return await services.postAsync({
            url: `/${TOPICS_PATH}/handouts/events`,
            body: { inputs, latitude, longitude },
            headers: {
                token
            },
            hasToken: false
        });
    },

    postConversationMessage: async ({ conversationId, message, context, files }) => {
        return await services.postAsync({
            url: `/topics/ai-conversations`,
            body: { conversationId, message, context, files },
            hasToken: true,
            timeout: 30000
        });
    },

    getConversation: async (id) => {
        return await services.getAsync({
            url: `/topics/ai-conversations/${id}`,
            hasToken: true,
            timeout: 10000
        });
    },

    getConversations: async (cursor) => {
        const url = cursor
            ? `/topics/ai-conversations?cursor=${cursor}`
            : `/topics/ai-conversations`;
        return await services.getAsync({ url, hasToken: true, timeout: 10000 });
    },

    deleteConversation: async (id) => {
        return await services.deleteAsync({
            url: `/topics/ai-conversations/${id}`,
            hasToken: true,
            timeout: 10000
        });
    }
}